import Vue from "vue";

// 文件
Vue.filter("fileTypeImg", (file) => {
  var files = JSON.parse(file);
  if (files.length > 0) {
    var fileitem = files[0];
    var suffix = fileitem.suffix;
    if (suffix == 'xls' || suffix == 'xlsx') {
      return '#icon-biaoge'
    } else if (suffix == 'doc' || suffix == 'docx') {
      return "#icon-wendang1";
    } else if (suffix == 'ppt' || suffix == 'pptx') {
      return "#icon-PPT";
    } else if (suffix == 'pdf') {
      return "#icon-PDF";
    } else if (suffix == 'png' || suffix == 'jpg' || suffix == 'jpeg') {
      return "#icon-filetype-img";
    } else if (suffix == 'wma' || suffix == 'mp3') {
      return "#icon-yinle";
    } else if (suffix == 'flv' || suffix == 'rmvb' || suffix == 'mp4' || suffix == 'mvb') {
      return "#icon-shipin2";
    } else {
      return '#icon-a-icon-unknownfiletype'
    }
  } else {
    return '#icon-a-icon-unknownfiletype'
  }
})

// 头像
Vue.filter("fileHeaderImg", (value) => {
  if (value && value.length != 0 && value.indexOf('[') != -1) {
    var zp = JSON.parse(value)
    if (zp.length > 0) {
      var imgObj = zp[0];
      return dsf.url.getWebPath(imgObj.relativePath)
    } else {
      return dsf.config.setting_public_user_default_header
    }
  } else {
    return dsf.config.setting_public_user_default_header
  }
})
